import { Component, Injector } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

const PLAY_STORE_URL_CONSTANT = 'https://play.google.com/store/apps/details?id=co.rapicredit';
@Component({
  selector: 'app-unlock-card',
  templateUrl: './unlock-card.component.html',
  styleUrls: ['./unlock-card.component.scss'],
})
export class UnlockCardComponent {
  private readonly dialogRef: MatDialogRef<UnlockCardComponent>;

  public isLoading: boolean;

  constructor(private readonly injector: Injector) {
    this.dialogRef = this.injector.get(MatDialogRef);
    this.isLoading = false;
  }

  public close(): void {
    this.dialogRef.close();
  }

  public continueActionFn(): void {
    window.location.href = PLAY_STORE_URL_CONSTANT;
  }
}
